import React, {Component} from "react";
import PropTypes from "prop-types";

import styles from "./breadcrumbs.module.scss";

export class Breadcrumbs extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        path: PropTypes.string
      })
    ).isRequired
  };
  isLastItem = (i) => {
    return this.props.items.length - 1 === i;
  };
  render() {
    const breadcrumbs = this.props.items.map((item, i) => {
      if (this.isLastItem(i)) {
        return (
          <li key={i} className={styles.item}>
            <span>{item.title}</span>
          </li>
        );
      }
      return (
        <li
          key={i}
          className={styles.item}
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <a
            href={item.path}
            className={styles.link}
            itemType="https://schema.org/Thing"
            itemProp="item"
          >
            <span itemProp="name">{item.title}</span>
          </a>
          <meta itemProp="position" content={i + 1} />
        </li>
      );
    });
    return (
      <ul
        className={styles.root}
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {breadcrumbs}
      </ul>
    );
  }
}

export default Breadcrumbs;
